import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ConvexClientProvider.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
